module.exports = __webpack_public_path__ + "img/welcome_trade_grayc.8810439d.png";